import Swiper from "swiper";
import { register } from 'swiper/element/bundle';
register();

class SwiperGallery {
  constructor() {
    const swiperGalleries = document.querySelectorAll('.swiper--gallery');

    let swiperId = '';

    swiperGalleries.forEach(swipergallery => {
      swiperId = swipergallery.id;

      let breakpointsTemplate = "";

      if (swipergallery.classList.contains("swiper--gallery--photo456x304")) {
        breakpointsTemplate = {
          0: {
            spaceBetween: 8,
            slidesPerGroup: 1,
          },
          500: {
            spaceBetween: 8,
            slidesPerGroup: 2,
          },
          750: {
            spaceBetween: 8,
            slidesPerGroup: 3,
          },
          768: {
            spaceBetween: 12,
            slidesPerGroup: 1,
          },
          940: {
            spaceBetween: 12,
            slidesPerGroup: 2,
          },
          1024: {
            spaceBetween: 12,
            slidesPerGroup: 2,
          },
          1420: {
            spaceBetween: 12,
            slidesPerGroup: 3,
          },
        }
      }

      if (swipergallery.classList.contains("swiper--gallery--tile222x408")) {
        breakpointsTemplate = {
          0: {
            spaceBetween: 8,
            slidesPerGroup: 2,
          },
          490: {
            spaceBetween: 8,
            slidesPerGroup: 3,
          },
          648: {
            spaceBetween: 8,
            slidesPerGroup: 4,
          },
          768: {
            spaceBetween: 12,
            slidesPerGroup: 3,
          },
          940: {
            spaceBetween: 12,
            slidesPerGroup: 4,
          },
          1210: {
            spaceBetween: 12,
            slidesPerGroup: 5,
          },
          1210: {
            spaceBetween: 12,
            slidesPerGroup: 5,
          },
          1210: {
            spaceBetween: 12,
            slidesPerGroup: 6,
          }
        }
      }

      const swiperGallery = new Swiper(`#${swiperId}`, {
        // Optional parameters
        navigation: {
          nextEl: `.swiper-button-next--${swiperId}`,
          prevEl: `.swiper-button-prev--${swiperId}`,
        },
        slidesPerView: "auto",
        slidesPerGroupAuto: true,
        freeMOde: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        simulateTouch: true,
        breakpoints: breakpointsTemplate,
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      });
    })
  }
}

export default SwiperGallery